<template>
  <Modal
    v-model="isOpen"
    :title
    :titleIcon="icon && { icon, color: status }"
    persistent
  >
    <p class="ConfirmDialog-description">
      {{ description }}
    </p>

    <template #actionSecondary>
      <ActionButton
        data-testid="confirm-dialog-cancel-button"
        variant="primary"
        size="md"
        :color="status"
        @click="primaryConfirm ? handleConfirm() : handleCancel()"
      >
        {{ primaryConfirm ? confirmLabelValue : cancelLabelValue }}
      </ActionButton>
    </template>

    <template #actionPrimary>
      <ActionButton
        data-testid="confirm-dialog-confirm-button"
        variant="tertiary"
        size="md"
        @click="primaryConfirm ? handleCancel() : handleConfirm()"
      >
        {{ primaryConfirm ? cancelLabelValue : confirmLabelValue }}
      </ActionButton>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@cvo/i18n/composables/useI18n';
import ActionButton from '../../atoms/ActionButton/ActionButton.vue';
import Modal from '../Modal/Modal.vue';
import type { ConfirmDialogProps, ConfirmDialogEmits } from './ConfirmDialog.model';

const props = defineProps<ConfirmDialogProps>();

const emit = defineEmits<ConfirmDialogEmits>();

const { t } = useI18n();

const isOpen = defineModel<boolean>({ default: false });

const confirmLabelValue = computed(() => props.confirmLabel ?? t('ui.components.confirmDialog.confirm'));
const cancelLabelValue = computed(() => props.cancelLabel ?? t('ui.components.confirmDialog.cancel'));

function handleConfirm(): void {
  isOpen.value = false;
  emit('confirm');
}

function handleCancel(): void {
  isOpen.value = false;
  emit('cancel');
}
</script>

<style lang="scss">
@layer cvo-ui {
  .ConfirmDialog {
    &-description {
      margin: 0;
    }
  }
}
</style>
